import styled from 'styled-components';
import { color } from 'styles/settings';
import { withModifiers } from 'utils';

export const Button = styled.div`
  margin-top: 5px;
  height: 48px;
  width: 48px;
  padding: 0;
  box-sizing: border-box;
  cursor: pointer;
  color: ${color.neutral.plainBlack};
  transition: color 0.2s;
  text-align: center;

  ${withModifiers('selected')`
        color: ${color.brand.gold};
    `}

  ${withModifiers('disabled')`
        opacity: 0.3;
        pointer-events: none;
    `}

    :hover {
    color: ${color.brand.gold};
  }

  ${withModifiers('danger')`
        :hover {
            color: ${color.brand.red};
        }
    `}

  ${withModifiers('linking')`
        :hover {
            color: ${color.brand.blue};
        }
    `}

    svg {
    height: 100%;
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: 100%;
  background-color: ${color.ui.backgroundGray};
`;

export const Container = styled.div`
  z-index: 2;
  position: absolute;
  width: 252px;
  height: 58px;
  background-color: ${color.neutral.white};
  line-height: 58px;
  border: 1px solid ${color.neutral.white};
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  left: calc(50% - 126px);
  top: -90px;
`;
